import React from "react";
import Disclaimer from "../pages/modules/web/components/Disclaimer";

const SupportFooter = () => {
  return <Disclaimer></Disclaimer>;
};

export default SupportFooter;
